import React from "react";
import { injectIntl } from "react-intl";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import { useField } from "formik";
import TimePicker from "rc-time-picker";
import moment, { Moment } from "moment";
import "rc-time-picker/assets/index.css";
import {
  TimeFormat,
  TimeFormatWithSeconds,
} from "../../constants/time-picker-constant";

interface IProps {
  children: React.ReactNode;
  className: string;
  "data-testid"?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  value: string;
  disabled: boolean;
  shouldCheckPast?: boolean;
  min: any;
  minuteInterval?: number;
  localStateUpdate?: ()=> void;
}

const FormikFormTimePicker = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const errorClass = `${meta.error && meta.touched ? "error" : ""}`;

  const setMomentTime = (e: Moment) => {
    return moment().hour(e.hour()).minute(e.minute()).second(e.second());
  };

  const formattedvalue =
    field.value === null ? null : moment(field.value, TimeFormatWithSeconds);
  const parsedValue = field.value
    ? moment(field.value, "HH:mm", true) // or your chosen format
    : null;

  const TimePickerComponent: any = TimePicker;
  const dateTime = moment(field.value);
  const timeOnly = dateTime.isValid() ? dateTime.format("HH:mm") : null;

  return (
    <>
      <TimePickerComponent
        {...props}
        {...field}
        className={props.className + " " + errorClass}
        showSecond={false}
        clearIcon={<></>}
        format={TimeFormat}
        inputReadOnly={true}
        onChange={(e: moment.Moment) => {
          helpers.setValue(e?.format("HH:mm"));
          if(props?.localStateUpdate)
             props?.localStateUpdate();
        }}
        value={parsedValue}
        // inputIcon={<span className="material-symbols-outlined clock-icon" data-testid='timePickerOpen'>schedule</span>}
        disabled={props.disabled}
        getPopupContainer={(triggerNode: any) => {
          return triggerNode.parentNode;
        }}
        minTime={
          props.shouldCheckPast && props.shouldCheckPast === true
            ? props.min
            : null
        }
        disabledMinutes={() =>
          Array.from({ length: 60 }, (_, i) => i).filter(
            (m) => m % (props.minuteInterval || 5) !== 0
          )
        }
      />
      <FormikFormErrorHandler intl={props.intl} meta={meta} />
    </>
  );
};

export default injectIntl(FormikFormTimePicker);
